import { aceHeroSliderCssVariables } from "./ace-hero-slider.get-names";
import { getAceHeroSliderNames } from "./ace-hero-slider.get-names";
import { h, Host } from "@stencil/core";
import { getInlineCssColor, ResizeListener } from "../../utils";
export class AceHeroSlider {
    constructor() {
        this.backgroundColor = 'surface-glass--ambience-darken';
        this.windowWidth = document.documentElement.offsetWidth;
        this.numberOfSlides = 0;
        this.currentSlideIndex = 0;
        /**
         *
         */
        this.loadSlides = () => {
            // Select all children of the container that are not script or link elements.
            this.slidesNodes = this.hostElement.querySelectorAll(`.${this.names.CLASS.CONTAINER} > :not(script):not(link):not(style)`);
            this.numberOfSlides = this.slidesNodes.length;
            this.initAutoSliderIfNeeded();
        };
        this.initSlideSizesAndPosition = () => {
            // We get the offsetWidth instead of the clientWidth because we want the width *without including the scrollbar*.
            this.windowWidth = document.documentElement.offsetWidth;
            // We do it within a timeout of 1 to improve performance.
            setTimeout(() => {
                this.loadSlides();
                this.slidesNodes.forEach((item, index) => {
                    item.classList.add(this.names.CLASS.SLIDE);
                    if (this.numberOfSlides > 1) {
                        const slideElement = item.tagName.toLowerCase().includes('ace-hero-item') ? item : item.querySelector('ace-hero-item');
                        if (slideElement) {
                            slideElement['index'] = index;
                            slideElement['heroSliderKey'] = this.names.ID.ROOT;
                        }
                    }
                });
                this.bringCurrentSlideIntoView();
            }, 1);
        };
    }
    componentWillLoad() {
        var _a;
        this.names = getAceHeroSliderNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
    }
    componentDidLoad() {
        this.loadSlides();
        ResizeListener.getInstance().subscribe(this.initSlideSizesAndPosition);
    }
    disconnectedCallback() {
        ResizeListener.getInstance().unsubscribe(this.initSlideSizesAndPosition);
    }
    /**
     *
     * @private
     */
    getStandardEventObject() {
        return {
            lastSlideInView: this.currentSlideIndex,
            swiperId: this.names.ID.ROOT,
            numberOfSlidesInView: 1,
            totalSlides: this.numberOfSlides
        };
    }
    /**
     *
     * @private
     */
    initAutoSliderIfNeeded() {
        if (this.numberOfSlides > 1 && this.delay > 0) {
            this.stopAutoSlider();
            this.autoSlideInterval = setInterval(() => {
                this.handleNextClick();
            }, this.delay);
        }
    }
    stopAutoSlider() {
        if (this.autoSlideInterval) {
            clearInterval(this.autoSlideInterval);
        }
    }
    bringCurrentSlideIntoView() {
        // Process step by step:
        // -- remove current slide from all.
        // ---- add current slide class --> since the animation takes 1.2s it the scroll is not visible.
        // ------- scroll to item.
        this.slidesNodes.forEach((slide) => {
            slide.classList.remove(this.names.CLASS.SLIDE____CURRENT);
            // In case we have children.
            const slideElement = slide.tagName.toLowerCase().includes('ace-hero-item') ? slide : slide.querySelector('ace-hero-item');
            if (slideElement && (this.currentSlideIndex === slideElement.index || this.numberOfSlides === 1)) {
                slide.classList.add(this.names.CLASS.SLIDE____CURRENT);
                this.sliderEl.scrollLeft = this.windowWidth * this.currentSlideIndex;
            }
        });
    }
    handleNextClick(event = undefined) {
        if (this.numberOfSlides > 1) {
            let nextSlideIndex;
            // If not event it means we have to jump to the next slide.
            if (!event) {
                nextSlideIndex = this.currentSlideIndex + 1;
            }
            else {
                const details = event.detail;
                if (details && details['heroSliderKey'] === this.names.ID.ROOT) {
                    nextSlideIndex = details['currentHeroItemIndex'] + 1;
                }
                // The moment we interact with it, we stop the auto-slider
                this.stopAutoSlider();
            }
            if (nextSlideIndex >= this.numberOfSlides) {
                nextSlideIndex = 0;
            }
            this.currentSlideIndex = nextSlideIndex;
            this.bringCurrentSlideIntoView();
            this.slidesMoved.emit(this.getStandardEventObject());
        }
    }
    handlePrevClick(event) {
        if (this.numberOfSlides > 1) {
            const details = event.detail;
            if (details && details['heroSliderKey'] === this.names.ID.ROOT) {
                let prevSlideIndex = details['currentHeroItemIndex'] - 1;
                if (prevSlideIndex < 0) {
                    prevSlideIndex = this.numberOfSlides - 1;
                }
                this.currentSlideIndex = prevSlideIndex;
                this.bringCurrentSlideIntoView();
                // The moment we interact with it, we stop the auto-slider
                this.stopAutoSlider();
                this.slidesMoved.emit(this.getStandardEventObject());
            }
        }
    }
    // Removing this event listener give us a huge performance boost – but then this won't work with React components.
    handleHeroItemDidRender() {
        // By debouncing it we avoid running this function a bunch of times when the slider is initialised,
        // as all hero items fire the event relatively at the same time on the first load.
        // But for some reason it does not work when the slot changes. TODO: Investigate.
        // debounce(() => this.initSlideSizesAndPosition(), 100);
        this.initSlideSizesAndPosition();
    }
    render() {
        let inlineStyle = {
            [aceHeroSliderCssVariables.WIDTH]: this.windowWidth + 'px',
            [aceHeroSliderCssVariables.BACKGROUND_COLOR]: getInlineCssColor(this.backgroundColor)
        };
        return (h(Host, { key: 'dfe23608c9c922eefa775cad77b56511afc2058b', style: inlineStyle }, h("div", { key: 'fb7679d0775f228821e09dcc04c888f1fcb5548f', id: this.names.ID.ROOT, class: this.names.CLASS.ROOT, ref: el => (this.sliderEl = el) }, h("div", { key: '0c6f62917f2df79a8991b8948ea31c676079d9c8', class: this.names.CLASS.CONTAINER }, h("slot", { key: '82e8aa2502e476a02fd85cdc9a66d7b792e18e99' })))));
    }
    static get is() { return "ace-hero-slider"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-hero-slider.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-hero-slider.css"]
        };
    }
    static get properties() {
        return {
            "delay": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "When passed, it will enable the auto-slide feature with this number of milliseconds between transitions."
                },
                "getter": false,
                "setter": false,
                "attribute": "delay",
                "reflect": false
            },
            "backgroundColor": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "background-color",
                "reflect": false,
                "defaultValue": "'surface-glass--ambience-darken'"
            }
        };
    }
    static get states() {
        return {
            "windowWidth": {}
        };
    }
    static get events() {
        return [{
                "method": "slidesMoved",
                "name": "slidesMoved",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "hostElement"; }
    static get listeners() {
        return [{
                "name": "nextHeroItem",
                "method": "handleNextClick",
                "target": "document",
                "capture": false,
                "passive": false
            }, {
                "name": "prevHeroItem",
                "method": "handlePrevClick",
                "target": "document",
                "capture": false,
                "passive": false
            }, {
                "name": "heroItemDidRender",
                "method": "handleHeroItemDidRender",
                "target": "document",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=ace-hero-slider.js.map
